import React from 'react'

import Input from 'Components/Input'

export default React.memo((props) => {

  return (
    <Input disabled={props.disabled} title={props.title}
      onChange={props.onChangeInput}
      multi={props.multi}
      rowsMax={props.rowsMax}
      style={{ width: '100%' }}
      type={props.inputType || 'text'}
      value={props.data} id={props.name} />
  )
})



// WEBPACK FOOTER //
// ./app/Utilitaire/Component/Utilitaire/Other/InputTextBasic.js